module.exports = __webpack_public_path__ + "img/blog-770x420.a9e71315.jpg";